// src/services/analytics/providers/GoogleAnalyticsProvider.ts
import { AnalyticsProvider, AnalyticsEventParams } from "../types";

export class GoogleAnalyticsProvider implements AnalyticsProvider {
  name = "google-analytics";
  private trackingId: string;
  private initialized = false;

  constructor(trackingId: string) {
    this.trackingId = trackingId;
  }

  initialize(): void {
    if (this.initialized || !this.trackingId) return;

    // gtag should already be loaded via index.html
    if (typeof window.gtag === "function") {
      this.initialized = true;
      console.log(
        "Google Analytics has been initialized"
      );
    } else {
      console.warn(
        "Google Analytics: gtag not found. Make sure the script is loaded."
      );
    }
  }

  pageView(pagePath: string, pageTitle: string): void {
    if (!this.initialized) return;

    window.gtag("event", "page_view", {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }

  sendEvent(eventName: string, params?: AnalyticsEventParams): void {
    if (!this.initialized) return;

    window.gtag("event", eventName, params);
  }

  setUser(userId: string | null): void {
    if (!this.initialized) return;

    window.gtag("config", this.trackingId, {
      user_id: userId,
    });
  }
}
